import { createSlice } from "@reduxjs/toolkit";

const initialState: IHwReportState = {
  data: null,
  pageSize: 0,
  pageNumber: 0,
  totalCount: 0,
  showLoading: {
    sourceAction: "",
    state: false,
  },
  isLoading: false,
  isSuccess: false,
  Details: null,
};

export const hwReportSlice = createSlice({
  name: "hwReport",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      const { sourceAction, isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: sourceAction,
        state: true,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    resetLoading: (state, action) => {
      const { isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: "",
        state: false,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    replaceHwReport: (state, action) => {
      const { data, pageSize, pageNumber, totalCount } = action.payload;
      state.data = data;
      state.pageSize = pageSize;
      state.pageNumber = pageNumber;
      state.totalCount = totalCount;
    },

    setHwReportDetails: (state, action) => {
      state.Details = action.payload.data;
    },
  },
});

export const hwReportActions = hwReportSlice.actions;
export default hwReportSlice.reducer;
